import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';

import rootReducer from './reducers';
import history from './history';

export default (initialState) => {
  const middlewares = [thunkMiddleware, routerMiddleware(history)];
  const devInClient =
    process.env.NODE_ENV === 'development' && process.env.IN_BROWSER === true;

  const createStoreWithMiddleware = compose(
    applyMiddleware(...middlewares),
    devInClient && window.devToolsExtension
      ? window.devToolsExtension()
      : (f) => f
  )(createStore);

  const store = createStoreWithMiddleware(rootReducer, initialState);

  store.additionalReducers = {};

  return store;
};
